var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGriglia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09207 4H4.50832C3.78586 4 3.2002 4.58567 3.2002 5.30812V9.89188C3.2002 10.6143 3.78586 11.2 4.50832 11.2H9.09207C9.81453 11.2 10.4002 10.6143 10.4002 9.89188V5.30812C10.4002 4.58567 9.81453 4 9.09207 4Z",
    fill: "#A8B1CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09207 13.6001H4.50832C3.78586 13.6001 3.2002 14.1858 3.2002 14.9082V19.492C3.2002 20.2144 3.78586 20.8001 4.50832 20.8001H9.09207C9.81453 20.8001 10.4002 20.2144 10.4002 19.492V14.9082C10.4002 14.1858 9.81453 13.6001 9.09207 13.6001Z",
    fill: "#A8B1CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6917 4H14.1079C13.3855 4 12.7998 4.58567 12.7998 5.30812V9.89188C12.7998 10.6143 13.3855 11.2 14.1079 11.2H18.6917C19.4141 11.2 19.9998 10.6143 19.9998 9.89188V5.30812C19.9998 4.58567 19.4141 4 18.6917 4Z",
    fill: "#A8B1CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6917 13.6001H14.1079C13.3855 13.6001 12.7998 14.1858 12.7998 14.9082V19.492C12.7998 20.2144 13.3855 20.8001 14.1079 20.8001H18.6917C19.4141 20.8001 19.9998 20.2144 19.9998 19.492V14.9082C19.9998 14.1858 19.4141 13.6001 18.6917 13.6001Z",
    fill: "#A8B1CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGriglia);
export default __webpack_public_path__ + "static/media/griglia.7e70deff64ef3e890c39428bd16342c4.svg";
export { ForwardRef as ReactComponent };